import { Component, OnInit } from '@angular/core';
import {Observable, timer} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DestroyService} from '../../shared/services/destroy/destroy.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  providers: [DestroyService],
})
export class UnauthorizedComponent implements OnInit {

  private readonly redirectTimer$: Observable<number> = timer(2000);

  constructor(private destroy$: DestroyService,
              private router: Router) { }

  ngOnInit(): void {
    this.redirectTimer$.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.router.navigate(['/']));
  }

}
